const getDefaultState = () => {
  return {
    signUp: false,
    // signUp: null,
    signUpSet: false,
    isModalOpen: false,
    modalState: false,
  }
}

const state = getDefaultState()

const getters = {
  isSignUp: state => state.signUp,
  isSignUpSet: state => state.signUpSet,
  modalOpen: state => state.isModalOpen,
  modalState: state => state.modalState,
}

const mutations = {
  setSignUp: (state, data) => {
    // console.log("Data in setSignup login model", data);
    state.signUp = data
  },
  setSignUpSet: (state, data) => {
    // console.log("Data in setSignupSet login model", data);
    state.signUpSet = data
  },
  setModalState: (state, data) => {
    state.isModalOpen = data
  },
  openModal: state => {
    console.log("login modal set to true")
    state.modalState = true
  },
  closeModal: state => {
    console.log("login modal set to false")
    state.modalState = false
  },
}

const actions = {
  //
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/loginModel.js